import { render, staticRenderFns } from "./CommentList.vue?vue&type=template&id=349571c8&scoped=true&lang=pug&"
import script from "./CommentList.vue?vue&type=script&lang=ts&"
export * from "./CommentList.vue?vue&type=script&lang=ts&"
import style0 from "./CommentList.vue?vue&type=style&index=0&id=349571c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349571c8",
  null
  
)

export default component.exports